import React from 'react';
import Footer from './Footer/Footer';
import Header from './Header/Header';

function Master({ children }) {
  return (
    <div>
      <Header />
      <div className="container-main">
        <main>
          <div className="container-fluid">
            <div>{children}</div>
          </div>
          <Footer />
        </main>
      </div>
    </div>
  );
}

export default Master;
